<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="32"
    height="32"
    viewBox="0 0 30 30"
    class="social-icon logo-group"
  >
    <title id="xTitle">Link to X (formerly Twitter)</title>
    <g xmlns="http://www.w3.org/2000/svg" fill="none" fill-rule="evenodd">
      <path
        class="bg"
        d="M15 0C6.716 0 0 6.716 0 15s6.716 15 15 15 15-6.716 15-15S23.284 0 15 0z"
        fill="#FFF"
      />
      <path
        class="logo"
        d="M26.37,26l-8.795-12.822l0.015,0.012L25.52,4h-2.65l-6.46,7.48L11.28,4H4.33l8.211,11.971L12.54,15.97L3.88,26h2.65 l7.182-8.322L19.42,26H26.37z M10.23,6l12.34,18h-2.1L8.12,6H10.23z"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style scoped>
.social-icon:hover .bg {
  fill: theme('colors.accent-refi');
}
</style>
